import {Component} from '@angular/core';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';
import {v4 as uuidv4} from 'uuid';

@Component({
  selector: 'app-resource-google-slide-preview',
  templateUrl: './resource-google-slide-preview.component.html',
  styleUrls: ['./resource-google-slide-preview.component.css']
})
export class ResourceGoogleSlidePreviewComponent {
  data: any;

  UUID = uuidv4();

  htmlContent: SafeHtml = '';

  constructor(private domSanitizer: DomSanitizer) {
  }


  ngOnInit() {
    this.getSanitizedContent(this.data.googleSlideUrl)
  }

  getSanitizedContent(content) {
    this.htmlContent = this.domSanitizer.bypassSecurityTrustHtml(content);
  }

  ngAfterViewChecked(): void {
    const slideWrapper = $('.slide-wrapper-' + this.UUID);
    const slideWidth = slideWrapper.get(0).getBoundingClientRect().width
    const iframe = $(`.slide-wrapper-${this.UUID} iframe`);

    iframe.get(0)?.setAttribute('width', slideWidth.toString());
    iframe.get(0)?.removeAttribute('height');
    iframe.css('aspect-ratio', '3/1.825');
  }
}
